/**
 * 학습 제출 성공 방송. 진입점과 무관하게 제출 위저드와 화면에 열린 세션 목록을 연결한다.
 *
 * 제출 창은 Training 페이지 헤더와 사이드바 두 곳에서 열리고, 사이드바 진입점은 콜백을 주지 않는다.
 * 목록 패널은 그 창 아래에 마운트된 상태라 제출을 스스로 알 수 없다. 그래서 창이 성공을 여기에
 * 방송하고, 목록이 각자 다시 받는다.
 *
 * Owns: 구독자 집합과 방송 시점.
 * Does not own: 구독자가 할 일(다시 조회·표시 정책은 목록 패널이 맡는다)과 제출된 세션의 내용.
 * 서버는 제출 응답 시점에 세션을 이미 커밋하므로 목록은 다시 받기만 하면 새 세션을 받는다.
 */

type TrainingSubmittedListener = () => void;

const listeners = new Set<TrainingSubmittedListener>();

// 구독 해지 함수를 반환한다. 반환값을 void 로 고정해 useEffect cleanup 에 그대로 전달할 수 있다.
export function subscribeTrainingSubmitted(listener: TrainingSubmittedListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

// 제출 성공 1건을 방송한다. 구독자가 없으면 아무 일도 하지 않는다(목록이 열려 있지 않은 화면).
export function notifyTrainingSubmitted(): void {
  // 통지 중에 구독이 해지되어도 순회가 깨지지 않도록 스냅샷을 순회한다.
  for (const listener of Array.from(listeners)) {
    listener();
  }
}
